<template>
     <div class="header">
          <div class="main clearfix">
               <div class="logo">
                    <a href="/"><img src="../../assets/images/logo.png" alt=""></a>
               </div>
               <div class="nav">
                     <ul>
                         <li>
                              <router-link :to="{ name: 'home' }" :class="[$route.meta.nav == 'home' ? 'curr' : '']">首页</router-link>
                         </li>
                          <li>
                              <router-link :to="{ name: 'subPlatformlist' }" :class="[$route.meta.nav == 'subplatform' ? 'curr' : '']">大湾区分平台</router-link>
                         </li>
                         <li>
                              <router-link :to="{ name: 'material' }" :class="[$route.meta.nav == 'Foundation' ? 'curr' : '']">供需对接基地</router-link>
                         </li>
                         <li>
                              <router-link :to="{ name: 'unionnewslist' }" :class="[$route.meta.nav == 'overview' ? 'curr' : '']">协会概况</router-link>
                         </li>
                          <li>
                              <router-link :to="{ name: 'meeting' }" :class="[$route.meta.nav == 'activity' ? 'curr' : '']">会议展览</router-link>
                         </li>
                          <li>
                              <router-link :to="{ name: 'popsciactivity' }" :class="[$route.meta.nav == 'popsci' ? 'curr' : '']">科学普及</router-link>
                         </li>
                         <!-- <li>
                              <router-link :to="{ name: '' }" :class="[$route.meta.nav == '' ? 'curr' : '']">新闻中心</router-link>
                         </li> -->
                     </ul>
               </div>
               <!-- <div class="header-rigth">
                    <div class="search">
                          <a href="javascript:void(0)" @click="poptips"><span>搜索</span></a>
                    </div>
                    <div class="user">
                         <div class="login"><a href="javascript:void(0)" @click="poptips">登录注册</a></div>
                    </div>
               </div> -->
          </div>
     </div>
</template>

<script>
import { Toast } from "vant";
export default {
	data(){return{
    }},
    components:{

    },
    mounted: function () {
       
    },
    created(){
    },
    methods:{
        poptips : function () {
            setTimeout(function () {
                Toast({ message: "功能开发中~敬请期待" })
            }, 500);
        },
    }   
}
</script>

<style>

</style>